import { render } from "./Variations.vue?vue&type=template&id=63c653a1"
import script from "./Variations.vue?vue&type=script&lang=js"
export * from "./Variations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__